module.exports = __webpack_public_path__ + "39ef523c5b1efe6c0f5e7af7df740473.pdf";